import { OrderState } from '../types/orders';

/**
 * Input de `SAVE_ACTION` que el replay de la cola compound construye desde el
 * snapshot de `NEW_ACTION_DATA` (movido de `syncAction` sin tocar una línea de
 * su lógica, 2026-09-02).
 *
 * Vive aparte por una razón: la actuación básica del RV se siembra sin red y
 * su semilla tiene que producir, pasada por aquí, el MISMO input que el camino
 * online manda a `SAVE_ACTION`. El test de paridad (`basic-action-seed.spec`)
 * lo contrasta; sin este módulo no habría contra qué contrastar.
 *
 * 🔴 `registeredByUserId`: sin él el backend rechaza con
 * `ACTION_OPERATOR_REQUIRED` (400) y la cola lo trata como veneno permanente —
 * la actuación se DESCARTA. Cazado en tablet real el 2026-08-10.
 */
export function buildSaveActionInputFromForm(
  formData: Record<string, any>,
  ctx: { clientOpId: string; parentOrderId: string }
): Record<string, unknown> {
  const pkInitArray = formData.pkInit.replace(/ /g, '').split('+');
  const pkEndArray = formData.pkEnd.replace(/ /g, '').split('+');

  return {
    clientOpId: ctx.clientOpId,
    parentOrderId: ctx.parentOrderId,
    state: OrderState.Partial,
    creationDate: new Date().toISOString(),
    registerInitDate: formData.registerInitDate,
    pkInitKm: Number(pkInitArray[0]),
    pkInitMeter: Number(pkInitArray[1]),
    pkEndKm: Number(pkEndArray[0]),
    pkEndMeter: Number(pkEndArray[1]),
    track: formData.track,
    direction: formData?.direction ?? null,
    margin: formData?.margin ?? null,
    lane: formData.lane,
    concessionId: formData.concession,
    roadId: formData.road,
    capitolId: formData.capitol,
    subCapitolId: formData.subCapitol,
    ...(formData.predefine && { predefinedOrderId: formData.predefine }),
    description: formData.description,
    notes: formData.notes,
    activityId: formData?.actionActivity,
    ...(formData.registeredByUserId && {
      registeredByUserId: formData.registeredByUserId,
    }),
  };
}
